export class AsxIndexUtil {

    private static readonly Codes = [
        "XTL",
        "XFL",
        "XTO",
        "XJO",
        "XVI",
        "XNV",
        "XLD",
        "XKO",
        "XAO",
        "XMD",
        "XSO",
        "XAF",
        "XAT",
        "XPJ",
        "XDJ",
        "XSJ",
        "XDI",
        "XEC",
        "XEJ",
        "XFJ",
        "XXJ",
        "XGD",
        "XHJ",
        "XNJ",
        "XIJ",
        "XMJ",
        "XMM",
        "XNT",
        "XJR",
        "XTJ",
        "XUJ",
        "XAE",
        "XSY",
        "XFD",
        "XFT",
        "XJT",
        "XBK",
        "XBT",
        "XBN",
        "XEW",
        "XRE",
        "XET",
        "XIN"
    ];

    public static isIndex(code: string): boolean {
        return AsxIndexUtil.Codes.includes(code);
    }
}
